import React, { useState } from "react";
import "./Contact_Section.css";

import DemoIcon from "../../../Assets/Home/Contacts_Section/Prof.png";
import TickIcon from "../../../Assets/Home/Contacts_Section/GreenDot.png";
import CallIcon from "../../../Assets/Home/Contacts_Section/Phone.png";
import MailIcon from "../../../Assets/Home/Contacts_Section/Mail.png";

import BookSessionModal from "../../Forms/Contact_Section/BookSessionModal";

export default function DemoContact() {
  const [openSession, setOpenSession] = useState(false);

  return (
    <>
      <section id="demo" className="contact-wrapper">

        {/* LEFT CARD */}
        <div className="left-card">
          <div className="demo-header">
            <img src={DemoIcon} alt="" className="demo-icon-img" />
            <h2 className="demo-title">
              Scheduled <br /> <span>Personal Demo</span>
            </h2>
          </div>

          <p className="demo-desc">
            Get a customized demonstration tailored to your specific business
            needs. Our experts will show you exactly how Fulupo can transform your
            operations.
          </p>

          <ul className="demo-list">
            <li><img src={TickIcon} alt="" /> 45-minute personalized session</li>
            <li><img src={TickIcon} alt="" /> Live feature demonstration</li>
            <li><img src={TickIcon} alt="" /> Q&A with AI experts</li>
            <li><img src={TickIcon} alt="" /> Custom pricing discussion</li>
          </ul>

          {/* OPEN MODAL */}
          <button
            className="schedule-btn"
            onClick={() => setOpenSession(true)}
          >
            Schedule Demo
          </button>
        </div>

        {/* RIGHT CARD */}
        <div className="right-card">
          <h2 className="right-title">
            Talk to <span>Our Experts</span>
          </h2>

          <p className="right-desc">
            Have specific questions about implementation, pricing, or integration?
            Connect directly with our AI specialists for immediate assistance.
          </p>

          <div className="contact-info-group">
            <div className="info-row">
              <div className="circle-icon">
                <img src={CallIcon} alt="call" className="circle-inner-icon" />
              </div>
              <div className="call-us">
                <h4>Call Us</h4>
                <p><a href="tel:+919600043880" className="contact-link">+91 9600043880</a></p>
              </div>
            </div>

            <div className="info-row">
              <div className="circle-icon">
                <img className="circle-inner-icon mail" src={MailIcon} alt="mail" />
              </div>
              <div className="email-us">
                <h4>Email Us</h4>
                <p>
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=fulupoaistore@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    fulupoaistore@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODAL */}
      {openSession && (
        <BookSessionModal onClose={() => setOpenSession(false)} />
      )}
    </>
  );
}
